function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import React, { useEffect, useState } from 'react';
import FontAwesome from 'react-fontawesome';
import { ClipLoader } from 'react-spinners';
import { useId, Collapse, Box } from '@applyboard/ui-components';
import MoreOptions from "../../../../components/core/ui/MoreOptions";
import { getColor } from "../../../../components/style";
import { Row, RowWrapper, ExpandMarker, SidebarRowTitle, SidebarRowContent, SidebarRowExpandedContent, SidebarRowMoreOptions, SidebarRowLoadingWrapper } from "./styles";
var SidebarRow = function SidebarRow(_ref) {
  var expandAll = _ref.expandAll,
    content = _ref.content,
    expandedContent = _ref.expandedContent,
    loading = _ref.loading,
    options = _ref.options,
    title = _ref.title,
    show = _ref.show,
    noticeComponent = _ref.noticeComponent;
  var titleId = useId();
  var sectionId = useId();
  var cy = "student-sidebar-".concat(title.replace(/\s+/g, '-').replace(/[()/]/g, '').toLowerCase());
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  useEffect(function () {
    if (!expandedContent) {
      return;
    }
    setExpanded(expandAll);
  }, [expandAll]);
  return /*#__PURE__*/React.createElement(Row, {
    "data-cy": cy,
    show: show,
    role: "region",
    "aria-label": "Sidebar ".concat(title, " row")
  }, /*#__PURE__*/React.createElement(RowWrapper, {
    expanded: expanded
  }, /*#__PURE__*/React.createElement(SidebarRowTitle, {
    id: titleId
  }, title, ":"), /*#__PURE__*/React.createElement(SidebarRowContent, null, content), options && /*#__PURE__*/React.createElement(SidebarRowMoreOptions, null, /*#__PURE__*/React.createElement(MoreOptions, {
    options: options
  })), /*#__PURE__*/React.createElement(SidebarRowLoadingWrapper, {
    loading: loading
  }, /*#__PURE__*/React.createElement(ClipLoader, {
    size: 18,
    color: getColor('blue')
  })), expandedContent && /*#__PURE__*/React.createElement(ExpandMarker, {
    "aria-expanded": expanded,
    onClick: function onClick() {
      return setExpanded(!expanded);
    },
    "aria-label": "Toggle ".concat(title, " section"),
    "aria-controls": sectionId
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "chevron-right"
  }))), /*#__PURE__*/React.createElement(Box, {
    mb: 1
  }, noticeComponent), /*#__PURE__*/React.createElement(Collapse, {
    role: "region",
    "aria-labelledby": titleId,
    id: sectionId,
    "in": expanded
  }, /*#__PURE__*/React.createElement(SidebarRowExpandedContent, null, expandedContent)));
};
export default SidebarRow;